import { createContext, useContext } from 'react';
import { BehaviorSubject, Subject } from 'rxjs';

interface ICredential { username: string, password: string };
export class AppStore {
  // trigger page loading screen
  appLoadingStateEvent = new BehaviorSubject<boolean>(false);
  headerToggleEvent = new Subject<boolean>();
  productClaimToggleEvent = new Subject<boolean>();
  arResourcesLoadEvent = new Subject<any>();
  aFrameModelLoadedEvent = new Subject<any>();
  initialPageUrl = new BehaviorSubject<string>('');
  // FIXME temp credential
  appCredential: BehaviorSubject<ICredential> = new BehaviorSubject({ username: '', password: '' });
}

export const Context = createContext<AppStore>(new AppStore());

export const useAppContext = (): AppStore => useContext(Context);
